<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout
            :justify-start="$vuetify.breakpoint.name !== 'xs' ? true : false"
            :justify-center="$vuetify.breakpoint.name == 'xs' ? true : false"
            wrap
            pt-6
          >
           <v-flex xs12 sm6 md6 lg3>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md2 lg2 pt-1 pl-5 text-center>
                 <v-img width="30px" src="./../../assets/images/add.svg"></v-img>
              </v-flex>
              <v-flex xs9 sm9 md10 text-center>
                <span
                  style="
                    font-family: nunitosansbold;
                    font-size: 20px;
                    color: #000000;
                  "
                  >Add New Students
                </span>
              </v-flex>
            </v-layout>
           </v-flex>
            <v-flex xs12 sm6 md6 lg9>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md2 lg1 pl-10 pt-1 text-center>
                <v-img width="30px" src="./../../assets/images/Path 753-3.svg"></v-img>
              </v-flex>
              <v-flex xs7 py-2 py-sm-0 align-self-center sm6 md7 lg8 xl8 pl-5>
              <router-link :to="'/studentList'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >Students List</span
                >
              </router-link>
            </v-flex>
            </v-layout>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-layout justify-center wrap pb-4 v-if="display">
              <v-flex xs12 pa-2>
                <v-card outlined v-if="lastItem">
                  <v-card-text>
                    <v-layout justify-center wrap>
                      <v-flex xs12 sm2 md1 text-center>
                        <v-avatar style="cursor: pointer" size="60">
                          <v-img :src="mediaURL + lastItem.user.photo" />
                        </v-avatar>
                      </v-flex>
                      <v-flex xs11>
                        <v-layout justify-center wrap>
                          <v-flex xs2 sm2 md2 lg1 pr-1 text-center>
                            <v-icon color="#FFBA00"
                              >mdi-account-check-outline</v-icon>
                          </v-flex>
                          <v-flex xs8 sm8 md9 lg10>
                            <span
                              style="
                                color: #9b9b9b;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Student Profile Added Successfully</span
                            ><br />
                          </v-flex>
                          <v-flex xs2 sm2 md1 lg1 align-self-end>
                            <v-icon size="15px" color="#A8A8A8"
                              >mdi-close-circle</v-icon
                            >
                          </v-flex>
                          <v-flex xs12>
                            <v-layout
                              :justify-start="
                                $vuetify.breakpoint.name !== 'xs' ? true : false
                              "
                              :justify-center="
                                $vuetify.breakpoint.name == 'xs' ? true : false
                              "
                              wrap
                              pt-2
                            >
                              <v-flex
                                xs8
                                sm6
                                md3
                                pl-md-4
                                lg3
                                pl-lg-5
                                pr-lg-9
                                align-self-center
                                text-left
                              >
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >{{ lastItem.user.firstName }}
                                  {{ lastItem.user.lastName }}</span
                                >
                              </v-flex>
                              <v-spacer
                                v-if="$vuetify.breakpoint.name !== 'xs'"
                              ></v-spacer>
                              <v-flex align-self-center xs8 sm6 md1 text-left>
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >{{ lastItem.class.className }}</span
                                >
                              </v-flex>
                              <!-- <v-flex align-self-center pl-md-8 xs8 sm6 md3>
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >No.13</span
                                >
                              </v-flex> -->
                              <v-flex xs8 sm6 md3>
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >Adm.No. {{ lastItem.admissionnumber }}</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout justify-start wrap>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="standard"
                  dense
                  style="font-family: nunitosanssemibold"
                  outlined
                  label="Class"
                  :items="standardArray"
                  item-text="standardName"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="division"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Section"
                  :items="section"
                  item-text="divisionName"
                  item-value="_id"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap>
              <v-flex xs12 text-center v-if="file">
                <!-- <img
                  v-if="filePreview"
                  :src="filePreview"
                  v-show="showFilePreview"
                  width="150px"
                  height="150px"
                  class="align-center"
                  contain
                /> -->
                <span>{{ file.name }}</span>
              </v-flex>
              <v-flex xs12 md4 offset-md4>
                <v-btn
                  block
                  small
                  dark
                  height="50px"
                  color="#9B8DFD"
                  @click="$refs.showFile.click()"
                >
                  <v-icon style="color: #ffffff">mdi-note-text-outline</v-icon>
                  <span style="font-family: nunitosanssemibold"
                    >UPLOAD STUDENT INFO SHEET</span
                  >
                </v-btn>
                <input
                  v-show="false"
                  id="file"
                  ref="showFile"
                  multiple="multiple"
                  type="file"
                  @change="showFile"
                />
                <v-layout justify-center wrap pt-2>
                  <v-flex xs12 text-center>
                    <span style="font-family: nunitosansregular; color: #8f8f8f"
                      >Upload One or Multiple Student Data</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4 py-2 text-right>
                <a
                  :href="'http://52.66.213.94/u/1625479788364.xlsx'"
                  style="text-decoration: none"
                >
                  <v-btn small plain color="#9B8DFD">
                    <span>Download Template</span>
                    <v-icon>mdi-download-outline</v-icon>
                  </v-btn>
                </a>
              </v-flex>
            </v-layout>
            <v-form v-model="addslider" ref="addslider">
              <v-layout justify-center wrap pt-8>
                <v-flex xs12 pl-2>
                  <span style="color: #000000; font-family: nunitosansbold"
                    >Add Student Information</span
                  >
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.firstName"
                    class="text"
                    label="First Name"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.lastName"
                    class="text"
                    label="Last Name"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-select
                    dense
                    label="Gender"
                    outlined
                    class="text"
                    v-model="student.gender"
                    :items="genders"
                    hide-details
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="student.dob"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="student.dob"
                        label="DOB"
                        readonly
                        outlined
                        dense
                        class="text"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="student.dob"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(student.dob)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.admissionnumber"
                    class="text"
                    label="Admission Number"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.email"
                    class="text"
                    label="Email"
                    :rules="emailRules"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.phone"
                    class="text"
                    label="Contact"
                    outlined
                    dense
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.phone2"
                    class="text"
                    label="Contact"
                    outlined
                    type="number"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pa-2>
                  <v-text-field
                    v-model="student.address"
                    class="text"
                    label="Address"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pl-2 pb-5>
                <v-flex xs12>
                  <img
                    v-if="imagePreview"
                    :src="imagePreview"
                    v-show="showPreview"
                    width="150px"
                    height="150px"
                    class="align-center"
                    contain
                  />
                </v-flex>
                <v-flex xs12 sm7 md5 lg4>
                  <v-btn
                    width="180px"
                    block
                    tile
                    depressed
                    :ripple="false"
                    class="text-capitalize"
                    color="#F6F5FF"
                    @click="$refs.showImage.click()"
                  >
                    <v-layout justify-center wrap>
                      <v-flex xs2 sm2 md2 text-left>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs10 sm8 md8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            color: #020202;
                            font-size: 12px;
                          "
                          >UPLOAD PROFILE PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-btn>
                  <input
                    v-show="false"
                    accept="image/*"
                    id="file"
                    ref="showImage"
                    multiple="multiple"
                    type="file"
                    @change="showImage"
                  />
                </v-flex>
              </v-layout>
              <v-flex xs12 pa-2>
                <div class="dottedline"></div>
              </v-flex>
              <v-layout justify-start wrap pt-3>
                <v-flex xs12 pa-2>
                  <v-text-field
                    v-model="student.fatherName"
                    class="text"
                    label="Fathers Name"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.fatherMobile"
                    class="text"
                    label="Contact"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    :rules="emailRules"
                    v-model="student.fatherEmail"
                    class="text"
                    label="Email"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pl-2 pb-5>
                <v-flex xs12 sm7 md5 lg4>
                  <v-flex xs12>
                    <img
                      v-if="imagePreviewFather"
                      :src="imagePreviewFather"
                      v-show="showPreviewFather"
                      width="150px"
                      height="150px"
                      class="align-center"
                      contain
                    />
                  </v-flex>
                  <v-btn
                    width="180px"
                    block
                    tile
                    depressed
                    :ripple="false"
                    class="text-capitalize"
                    color="#F6F5FF"
                    @click="$refs.showImageFather.click()"
                  >
                    <v-layout justify-center wrap>
                      <v-flex xs2 smw2 md2 text-left>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs10 sm8 md8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            color: #020202;
                            font-size: 12px;
                          "
                          >UPLOAD PROFILE PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-btn>
                  <input
                    v-show="false"
                    accept="image/*"
                    id="file"
                    ref="showImageFather"
                    multiple="multiple"
                    type="file"
                    @change="showImageFather"
                  />
                </v-flex>
              </v-layout>
              <v-flex xs12 pa-2>
                <div class="dottedline"></div>
              </v-flex>
              <v-layout justify-start wrap pt-3>
                <v-flex xs12 pa-2>
                  <v-text-field
                    v-model="student.motherName"
                    class="text"
                    label="Mothers Name"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    v-model="student.motherMobile"
                    class="text"
                    label="Contact"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    :rules="emailRules"
                    v-model="student.motherEmail"
                    class="text"
                    label="Email"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pl-2 pb-5>
                <v-flex xs12 sm7 md5 lg4>
                  <v-flex xs12>
                    <img
                      v-if="imagePreviewMother"
                      :src="imagePreviewMother"
                      v-show="showPreviewMother"
                      width="150px"
                      height="150px"
                      class="align-center"
                      contain
                    />
                  </v-flex>
                  <v-btn
                    width="180px"
                    block
                    tile
                    depressed
                    :ripple="false"
                    class="text-capitalize"
                    color="#F6F5FF"
                    @click="$refs.showImageMother.click()"
                  >
                    <v-layout justify-center wrap>
                      <v-flex xs2 sm2 md2 text-left>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs10 sm8 md8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            color: #020202;
                            font-size: 12px;
                          "
                          >UPLOAD PROFILE PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-btn>
                  <input
                    v-show="false"
                    accept="image/*"
                    id="file"
                    ref="showImageMother"
                    multiple="multiple"
                    type="file"
                    @change="showImageMother"
                  />
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout justify-center wrap py-8>
              <v-flex xs12 sm6 md4>
                <v-btn
                  @click="validateInput"
                  block
                  dark
                  :disabled="!addslider"
                  height="50px"
                  color="#9B8DFD"
                >
                  <span style="font-family: nunitosanssemibold">SUBMIT</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      student: {
        firstName: "",
        lastName: "",
        gender: "",
        admissionnumber: "",
        dob: "",
        email: "",
        phone: "",
        phone2: "",
        address: "",
        fatherName: "",
        fatherMobile: "",
        fatherEmail: "",
        motherName: "",
        motherMobile: "",
        motherEmail: "",
        classid: "",
        name: "Test",
      },
      addslider: false,
      menu: false,
      standard: "",
      division: "",
      showsnackbar: false,
      msg: "",
      timeout: 5000,
      filePreview: false,
      showFilePreview: false,
      showPreview: false,
      showPreviewFather: false,
      showPreviewMother: false,
      bank: [],
      file: null,
      file1: null,
      file2: null,
      file3: null,
      coverimage: "",
      imagePreview: "",
      imagePreviewFather: "",
      imagePreviewMother: "",
      selectedFiles: [],
      image: null,
      hover: false,
      appLoading: false,
      ServerError: false,
      sideNav: false,
      sideNav2: false,
      sideNav3: false,
      studentList: [],
      id: "",
      fId: "",
      mId: "",
      page: 1,
      classArray: [],
      standardArray: [],
      section: [],
      data: [],
      display:false,
      timeOutClass: null,
      genders: ["Male", "Female", "Other"],
      emailRules: [
        (v) => !!v || "Email is Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  computed: {
    lastItem() {
      return this.data.slice(0)[0];
    },
  },
  watch: {
    standard() {
      this.getClass();
    },
    division() {
      this.getClass();
    },
  },
  beforeMount() {
    // const timeout = document.getElementsByClassName('classname')
    // setTimeout(this.timeOutClass, 5000); //milliseconds until timeout//
    // function hideElement() {
    //   timeout.style.display = 'none'
    // }
  },
  mounted() {
    this.getStandard();
    this.getSection();
    this.getClass();
    this.getData();
     this.testFunction()
      if (this.student) this.student.dob = "2000-01-01";
  },
  methods: {
     testFunction: function () {
      // var v = this;
      setTimeout(function () {
        this.display = false;
    }, 3000);
   },
    validateInput() {
      if (!this.student.firstName) {
        this.msg = "Please Provide First name";
        this.showsnackbar = true;
        return;
      } else if (!this.student.lastName) {
        this.msg = "Please Provide Last name";
        this.showsnackbar = true;
        return;
      } else if (!this.student.gender) {
        this.msg = "Please Provide Gender";
        this.showsnackbarr = true;
        return;
      } else if (this.student.fatherMobile.length != 10) {
        this.msg = "Please enter valid father number";
        this.showsnackbar = true;
        return;
      } else if (this.student.motherMobile.length != 10) {
        this.msg = "Please enter valid mother number";
        this.showsnackbar = true;
        return;
      } else if (!this.student.admissionnumber) {
        this.msg = "Please Provide Admission Number";
        this.showsnackbar = true;
        return;
      } else if (!this.student.email) {
        this.msg = "Please Provide Email";
        this.showsnackbar = true;
        return;
      } else if (!this.student.dob) {
        this.msg = "Please Provide Date of Birth";
        this.showsnackbar = true;
        return;
      } else if (!this.student.address) {
        this.msg = "Please Provide Address";
        this.showsnackbar = true;
        return;
      } else if (!this.student.fatherName) {
        this.msg = "Please Provide Father Name";
        this.showsnackbar = true;
        return;
      } else if (!this.student.motherName) {
        this.msg = "Please Provide Mother Name";
        this.showsnackbar = true;
        return;
      } else if (!this.student.fatherMobile) {
        this.msg = "Please Provide Father Contact";
        this.showsnackbar = true;
        return;
      } else if (!this.student.motherMobile) {
        this.msg = "Please Provide Mother Contact";
        this.showsnackbar = true;
        return;
      } else if (!this.student.fatherEmail) {
        this.msg = "Please Provide Father Email";
        this.showsnackbar = true;
        return;
      } else if (!this.student.motherEmail) {
        this.msg = "Please Provide Mother Email";
        this.showsnackbar = true;
        return;
      } else if (!this.imagePreview) {
        this.msg = "Please Upload Student Photo";
        this.showsnackbar = true;
        return;
      } else if (!this.imagePreviewFather) {
        this.msg = "Please Upload Father Photo";
        this.showsnackbar = true;
        return;
      } else if (!this.imagePreviewMother) {
        this.msg = "Please Upload Mother Photo";
        this.showsnackbar = true;
        return;
      } else {
        this.addStudent(this.classid);
      }
    },
    showFile(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showFilePreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        this.uploadFile();
      }
    },
    showImage(e) {
      this.file1 = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file1.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
      }
    },
    showImageFather(e) {
      this.file2 = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImageFather.value = null;
        this.imagePreviewFather = e.target.result;
      };
      if (this.file2.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreviewFather = true;
      if (this.file2) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file2.name)) {
          reader.readAsDataURL(this.file2);
        }
      }
    },
    showImageMother(e) {
      this.file3 = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImageMother.value = null;
        this.imagePreviewMother = e.target.result;
      };
      if (this.file3.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreviewMother = true;
      if (this.file3) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file3.name)) {
          reader.readAsDataURL(this.file3);
        }
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/student/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.data = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getClass() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/getclass",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          standard: this.standard,
          division: this.division,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.classArray = response.data.data;
          if (response.data.status) {
            this.classid = response.data.data._id;
            console.log(this.classid);
            // this.addStudent(this.classid);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.standardArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    getSection() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/division/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.section = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addStudent(cid) {
      this.appLoading = true;
      this.student.classid = cid;
      axios({
        method: "POST",
        url: "/student/add",
        data: this.student,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Student Added Successully";
            this.id = response.data.data._id;
            this.fId = response.data.father._id;
            this.mId = response.data.mother._id;
            console.log(this.id);
            console.log(this.fId);
            console.log(this.mId);
            if (this.imagePreview && this.id) {
              console.log(this.imagePreview);
              this.uploadImageStudent(this.id);
            }
            if (this.imagePreviewFather && this.fId) {
              this.uploadImageFather(this.fId);
            }
            if (this.imagePreviewMother && this.mId) {
              this.uploadImageMother(this.mId);
            }
            Object.keys(this.student).forEach(
              (key) => (this.student[key] = null)
            );
            this.getData();
            this.testFunction()
            this.display=true;
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("doc", this.file);
      axios({
        method: "POST",
        url: "/excelimport/student/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.file = null;
            this.filePreview = null;
            this.showFilePreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Image.. Please Try Again Later";
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    uploadImageStudent(sid) {
      console.log(sid);
      let formData = new FormData();
      formData.append("photo", this.file1);
      formData.append("id", sid);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.imagePreview = null;
            this.showPreview = null;
            this.getData();
          } else {
            this.msg = "Can't Upload Image.. Please Try Again Later";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Image.. Please Try Again Later";
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    uploadImageFather(item1) {
      let formData = new FormData();
      formData.append("photo", this.file2);
      formData.append("id", item1);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.imagePreviewFather = null;
            this.showPreviewFather = null;
          } else {
            this.msg = "Can't Upload Image.. Please Try Again Later";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Image.. Please Try Again Later";
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    uploadImageMother(item2) {
      let formData = new FormData();
      formData.append("photo", this.file3);
      formData.append("id", item2);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.imagePreviewMother = null;
            this.showPreviewMother = null;
          } else {
            this.msg = "Can't Upload Image.. Please Try Again Later";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Image.. Please Try Again Later";
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.text {
  color: #5d5d5d;
  font-family: nunitosansregular;
}
.dottedline {
  border: none;
  border-top: 2px dashed rgb(208, 208, 208);
  color: #8181812f;
  /* background-color:#8181812F; */
  height: 1px;
  width: 100%;
}
</style>